module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-muscle-gain@2x.23a952c9.png";